const wishlist = {

    ui: {
        originPopin: null
    },

    init: function() {
        this.bindUI();
        this.bindEvents();
    },

    bindUI: function() {
        this.ui.$formEdit = $('.js-wishlist-edit');
        this.ui.$formAddProduct = $('.js-wishlist-add-product-ajax');
        this.ui.$formNew = $('.js-wishlist-new-ajax');
        this.ui.$openPopinNew = $('.js-wishlist-open-popin-new');
    },

    bindEvents: function() {
        this.ui.$formEdit.on('keyup','input', this.handleEdit.bind(this));
        this.ui.$formEdit.on('submit', this.handleSubmitEdit.bind(this));

        this.ui.$formAddProduct.on('submit', 'form', this.handleSubmitAddProduct.bind(this));
        this.ui.$formNew.on('submit', 'form', this.handleSubmitNew.bind(this));

        this.ui.$openPopinNew.on('click', this.handleOpenPopinNew.bind(this));
    },

    handleEdit: function(e) {
        let form = $(e.currentTarget).parents('form');
        if(this.ui.timer) {
            clearTimeout(this.ui.timer);
        }
        this.ui.timer = setTimeout(() => {
            form.submit();
        }, 1000);
    },
    handleSubmitEdit: function(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: (data) => {
                // console.log("success");
                // console.log(data);
            },
            error: (data) => {
                // console.log("error");
            }
        })
    },

    handleSubmitAddProduct: function(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: (data) => {
                // console.log("success");
                // console.log(data);
                let $parentPopin = $form.closest(".js-popin");
                $parentPopin.find(".js-wishlist-add-product-msg").hide()
                $parentPopin.find(".js-wishlist-add-product-msg-success-hide").hide()
                $parentPopin.find(".js-wishlist-add-product-msg-success").show()
            },
            error: (data) => {
                // console.log("error");
                let $parentPopin = $form.closest(".js-popin");
                $parentPopin.find(".js-wishlist-add-product-msg").hide()
                $parentPopin.find(".js-wishlist-add-product-msg-error").show()
                $parentPopin.find(".js-wishlist-add-product-msg-success-hide").show()
            }
        })
    },
    handleSubmitNew: function(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        let that = this;
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: (data) => {
                if(data.success == true){
                    $(".js-popin-close").click();
                    $(".js-display-popin[data-target='#"+that.ui.originPopin+"']").click();
                }else{
                    if(data.form){
                        that.ui.$formNew.find("form").parent().append($(data.form));
                    }
                }
            },
            error: (data) => {
            }
        })
    },
    handleOpenPopinNew: function(e) {
        e.preventDefault();
        let $btn = $(e.currentTarget);
        this.ui.originPopin = $btn.attr("data-origin-popin");
    }
};

module.exports = wishlist;